import { type PaymentAction } from '../paymentHandler';

interface PaypalResponse {
    PayPalUrl: string;
    Status: string;
}

export const paypalPaymentAction: PaymentAction = async(baseUrl, submissionId) => {
    const payload = new FormData();
    payload.append('SubmissionId', submissionId);

    const requestPaymentLink = await fetch(`${baseUrl}/api/PayPalV2`, {
        method: 'POST',
        body: payload,
    });

    if (!requestPaymentLink.ok) {
        throw new Error('Failed to fetch PayPal payment link');
    }

    const response: PaypalResponse = await requestPaymentLink.json();

    if (response.PayPalUrl) {
        window.location.href = response.PayPalUrl;
    }
};
